exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".section-menu[data-v-001240bc]{padding:0 25px;text-align:left;margin-top:40px}.section-menu .title[data-v-001240bc]{padding-left:16px;position:relative}.section-menu .title[data-v-001240bc]:before{content:\"\";width:5px;height:22px;background:#fff;position:absolute;left:0;top:28px}.section-menu .menu-info[data-v-001240bc]{padding:20px 0;border-bottom:1px solid #ccc}.section-menu .menu-info .menu-head[data-v-001240bc]{font-size:16px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;margin-bottom:4px}.section-menu .menu-info .menu-head>.menu-title[data-v-001240bc]{font-weight:700;position:relative}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-001240bc","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Menu.vue
// module id = e69T
// module chunks = 1